export enum Type {
    QUESTION = 'QUESTION'
}